<template>
  <div class="my-invites">
    <!-- 头部区域 -->
    <div class="header">
      <div class="header-left">
        <button class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <div class="title">我的邀请</div>
      </div>
    </div>


    <!-- 主要内容 -->
    <div class="content-container">
      <!-- 管理员推广位选择器 -->
      <div v-if="isAdmin" class="admin-selector">
        <label>推广位：</label>
        <el-select v-model="selectedPositionId" placeholder="请选择推广位" @change="onPositionChange" clearable>
          <el-option v-for="position in allPositions" :key="position.positionId"
            :label="`${position.positionName}  ${position.positionId ? '(' + position.positionId + ')' : ''}`"
            :value="position.positionId">
          </el-option>
        </el-select>
      </div>
      <!-- 推广码展示区域 -->
      <div class="invite-code-section">
        <div class="invite-code-display">
          <label>推广码:</label>
          <span class="invite-code">{{ currentInviteCode }}</span>
          <button @click="copyInviteCode" class="copy-btn">复制</button>
        </div>
        <div class="invite-link">
          <label>邀请链接:</label>
          <span class="invite-link-text">{{ inviteLink }}</span>
          <button @click="copyInviteLink" class="copy-btn">复制</button>
        </div>
      </div>

    </div>
    <!-- 邀请记录 -->
    <div class="invite-tree-section">
      <div class="section-title">邀请记录<span style="font-size: 12px;color: #42b983;">【被邀请人开单获得佣金并结佣后邀请人有奖励】</span></div>
      <div class="tree-container">
        <div v-if="loading" class="loading">加载中...</div>
        <div v-else-if="inviteTree.length === 0" class="no-data">
          暂无邀请记录
        </div>
        <el-tree v-else :data="inviteTree" :props="treeProps" node-key="positionId" :expand-on-click-node="false"
          class="invite-tree" :default-expand-all="false">
          <span class="custom-tree-node" slot-scope="{ data }" @click="handleNodeClick(data)">
            <div class="node-info">
              <span class="position-id">{{ data.positionId }}</span>
              <span class="position-id">【{{ data.positionName }}】</span>
              <!-- <span class="position-id" v-if="isAdmin">{{ (data.realName || '未实名') }}</span> -->
            </div>
            <!-- <div class="node-stats">
              <span class="stat-item">直接: {{ data.directChildren }}</span>
              <span class="stat-item">总计: {{ data.totalChildren }}</span>
            </div> -->
          </span>
        </el-tree>
      </div>
    </div>

  </div>
</template>

<script>
import { getMyInviteCode, getMyInvites, getAllPositionsForAdmin, getCurrentUser } from '@/utils/jdApi'
import { copyToClipboardWithMessage } from '@/utils/clipboard'

export default {
  name: 'MyInvites',
  data() {
    return {
      loading: false,
      inviteTree: [],
      fullTree: [], // 保存完整的邀请树，用于过滤
      // 管理员相关
      selectedPositionId: '',
      allPositions: [
        {
          positionId: '',
          positionName: '全部'
        }
      ],
      // el-tree配置
      treeProps: {
        children: 'children',
        label: 'positionId'
      },
      currentUser: null,
      currentInviteCode: "", // 当前显示的邀请码
    }
  },
  computed: {
    inviteLink() {
      return `${window.location.origin}/register?invite=${this.currentInviteCode}`
    },

    isAdmin() {
      return this.currentUser && this.currentUser.role === 'ADMIN'
    },

  },
  activated() {
    this.currentUser = getCurrentUser()
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        // 同时获取邀请码和邀请树
        const [codeRes, treeRes] = await Promise.all([
          getMyInviteCode(),
          getMyInvites()
        ])

        // 设置邀请码
        if (codeRes && codeRes.success) {
          this.currentInviteCode = codeRes.data || ''
        }

        // 设置邀请树
        if (treeRes && treeRes.success) {
          const data = treeRes.data || []
          this.fullTree = data
          this.inviteTree = data
          // 如果树中有数据，也可以从树中获取邀请码（作为备用）
          if (data.length > 0 && data[0].inviteCode && !this.currentInviteCode) {
            this.currentInviteCode = data[0].inviteCode
          }
        }

        // 如果是管理员，加载所有推广位
        if (this.isAdmin) {
          await this.loadAllPositions()
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },

    copyInviteCode() {
      copyToClipboardWithMessage(this.currentInviteCode, this, '推广码已复制到剪贴板', '复制失败')
    },

    copyInviteLink() {
      copyToClipboardWithMessage(this.inviteLink, this, '邀请链接已复制到剪贴板', '复制失败')
    },

    async loadAllPositions() {
      try {
        const response = await getAllPositionsForAdmin()
        if (response.success) {
          this.allPositions.push(...response.data)
        }
      } catch (error) {
        this.$message.error('获取推广位列表失败')
      }
    },

    async onPositionChange(positionId) {
      if (!positionId) {
        // 如果清空选择，恢复完整的邀请树和当前用户的邀请码
        this.inviteTree = this.fullTree
        // 重新获取当前用户的邀请码
        try {
          const codeRes = await getMyInviteCode()
          if (codeRes && codeRes.success) {
            this.currentInviteCode = codeRes.data || ''
          } else if (this.fullTree.length > 0 && this.fullTree[0].inviteCode) {
            // 如果获取失败，从树中获取
            this.currentInviteCode = this.fullTree[0].inviteCode
          }
        } catch (error) {
          console.error('获取邀请码失败:', error)
        }
        return
      }

      this.loading = true
      try {
        // 从完整的邀请树中过滤出指定推广位的邀请树
        this.inviteTree = this.filterInviteTreeByPositionId(this.fullTree, positionId)
        // 从过滤后的树中获取对应推广位的邀请码
        if (this.inviteTree.length > 0 && this.inviteTree[0].inviteCode) {
          this.currentInviteCode = this.inviteTree[0].inviteCode
        } else {
          // 如果过滤后的树中没有邀请码，尝试从完整树中查找该节点
          const targetNode = this.findNodeByPositionId(this.fullTree, positionId)
          if (targetNode && targetNode.inviteCode) {
            this.currentInviteCode = targetNode.inviteCode
          }
        }
      } catch (error) {
        this.$message.error('获取邀请树失败')
      } finally {
        this.loading = false
      }
    },

    // 在树中查找指定positionId的节点
    findNodeByPositionId(tree, targetPositionId) {
      for (const node of tree) {
        if (node.positionId === targetPositionId) {
          return node
        }
        if (node.children && node.children.length > 0) {
          const found = this.findNodeByPositionId(node.children, targetPositionId)
          if (found) return found
        }
      }
      return null
    },

    // 递归过滤邀请树，只显示指定推广位及其子节点
    filterInviteTreeByPositionId(tree, targetPositionId) {
      const result = []

      for (const node of tree) {
        if (node.positionId === targetPositionId) {
          // 找到目标节点，返回该节点及其所有子节点
          result.push(node)
        } else if (node.children && node.children.length > 0) {
          // 递归查找子节点
          const filteredChildren = this.filterInviteTreeByPositionId(node.children, targetPositionId)
          if (filteredChildren.length > 0) {
            // 如果子节点中有匹配的，创建新节点包含过滤后的子节点
            const newNode = { ...node }
            newNode.children = filteredChildren
            result.push(newNode)
          }
        }
      }

      return result
    },

    goBack() {
      this.$router.go(-1)
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      return new Date(dateTime).toLocaleString()
    },

    handleNodeClick(data) {
      // 跳转到邀请详情页，传递 positionId
      if (data && data.positionId) {
        this.$router.push({ name: 'InviteDetail', params: { positionId: data.positionId } })
      } else {
        console.warn('无法获取 positionId:', data)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.my-invites {
  height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
}

.content-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
}

.header {
  background: linear-gradient(135deg, #42b983, #369870);
  color: white;
  padding: 4px;
  margin-bottom: 10px;
  flex-shrink: 0;
  border-radius: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: white;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
  width: 20px;
  height: 20px;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.admin-selector {
  margin-bottom: 10px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
}

.admin-selector label {
  white-space: nowrap;
  color: #666;
}

.page-header {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.page-header h1 {
  margin: 0 0 20px 0;
  color: #333;
}

.invite-code-section {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.invite-code-display,
.invite-link {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
}

.invite-code-display label,
.invite-link label {
  color: #666;
  white-space: nowrap;
}

.code-container,
.link-container {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.invite-code,
.invite-link-text {
  flex: 1;
  padding: 4px 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  font-family: monospace;
  font-size: 14px;
  color: #495057;
  word-break: break-all;
  white-space: normal;
  overflow-wrap: break-word;
  min-height: 20px;
}

.copy-btn {
  padding: 8px 16px;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.copy-btn:hover {
  background: #369870;
}

.invite-tree-section {
  background: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.tree-container {
  height: calc(100vh - 245px);
  overflow: auto;
}

.loading,
.no-data {
  text-align: center;
  padding: 40px;
  color: #666;
}

/* .invite-tree {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 10px;
} */

.custom-tree-node {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 4px;
}

.node-info {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.position-id {
  font-weight: bold;
  color: #42b983;
  font-family: monospace;
  font-size: 15px !important;
}

.role-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}

.role-badge.admin {
  background: #dc3545;
  color: white;
}

.role-badge.leader {
  background: #007bff;
  color: white;
}

.role-badge.user {
  background: #6c757d;
  color: white;
}

.invite-level {
  background: #17a2b8;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}

.node-stats {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: #666;
}

.stat-item {
  white-space: nowrap;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .my-invites {
    padding: 10px;
  }

  .invite-code-section {
    flex-direction: column;
    gap: 10px;
  }

  .invite-code-display,
  .invite-link {
    min-width: auto;
  }

  .custom-tree-node {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .node-info {
    align-items: center;
    gap: 0px;
  }

  .node-stats {
    flex-direction: column;
    gap: 5px;
  }
}

::v-deep {
  .el-tree-node__children {
    .el-tree-node__content {
      padding-left: 10px !important;
    }
  }

  .el-tree-node__content>.el-tree-node__expand-icon {
    padding: 0px;
    margin-right: 4px;
  }

  .custom-tree-node {
    padding: 4px 4px 4px 0px;
  }
}
</style>
